<template>
	<div id="StepWizardAbout" class="text-left">
		<div v-if="showMediaManager" class="media--manager">
			<div class="nav-mediaManager p-4">
				<i
					class="fas fa-chevron-down"
					@click="showMediaManager = false"
				></i>
			</div>
			<MediaManager 
				@receiveMedias="addPictures($event)" 
				@closeTabs="closeTabs()"
			/>
		</div>
		<div class="title-area">
			<h4>{{ stepName }}</h4>
			<p>Escolha uma ou mais imagens que representem você ou seu negócio</p>
		</div>
		<div class="input-area mb-5">
			<div class="card p-2 my-2">
				<div class="row">
					<div class="col-auto my-2" @click="showMediaManager = true">
						<img
							class="img-fluid"
							src="../../assets/img/icons/add_media@2x.png"
							alt
						/>
					</div>
					<div
						class="col-auto text-center my-2 card--image"
						v-for="(picture, index) in aboutPictures"
						:key="index"
					>
						<BaseImage
							:source="picture"
							:customClass="'img-fluid'"
						/>
						<span class="span-close">
							<i
								class="fas fa-times-circle"
								@click="removeImage(index)"
							></i>
						</span>
					</div>
				</div>
			</div>
			<p class="mt-3 mb-0" v-if="aboutOptions.length > 0">
				Escolha uma descrição abaixo ou escreva sobre você ou seu
				negócio.
			</p>
			<masonry :cols="{ default: 2, 700: 1 }" key="1" :gutter="15">
				<div
					@click="selectOption(option)"
					v-for="option in aboutOptions"
					:key="option.id"
				>
					<div
						class="card p-2 my-4"
						:class="[isSelected(option) ? 'active' : '']"
					>
						<span
							v-if="option.ai"
							class="tagai" 
							>Criado com Inteligência Artificial</span>
						<p class="title--about">{{ getSiteName }}</p>
						<label>{{ getSegment }}</label>
						<p>{{ option.content }}</p>
					</div>
				</div>
			</masonry>
		</div>
	</div>
</template>

<script>
	import MediaManager from "@/components/organisms/MediaManager";
	import BaseImage from "@/components/atoms/BaseImage";
	export default {
		name: "StepWizardAbout",
		data() {
			return {
				showMediaManager: false,
				selectedOption: {},
				aboutOptions: [],
			};
		},
		props: {
			stepName: {
				type: String,
				required: false,
			},
		},
		components: {
			MediaManager,
			BaseImage,
		},
		created() {
			this.aboutOptions = this.$store.state.wizard.dataSite.aboutSetup.aboutList;
			this.selectedOption = this.$store.state.wizard.dataSite.aboutSetup.selected;
			if (this.selectedOption && this.selectedOption.content === null) {
				this.selectOption(this.aboutOptions[0]);
			}
		},
		mounted() {
			this.$emit("updateStep");
			this.$store.dispatch("WIZARD_BLOCK_NEXT", [false]);
		},
		methods: {
			isSelected(option) {
				if (option == this.selectedOption) {
					return true;
				} else {
					return false;
				}
			},
			addPictures(content) {
					let pictures = []
					content.forEach(element => {
						pictures.push(element.url)
					});
				this.$store.dispatch("ABOUT_ADD_PICTURE", [pictures]);
				this.showMediaManager = false;
			},
			closeTabs() {
				this.showMediaManager = false;
			},	
			selectOption(option) {
				this.selectedOption = option;
				this.$store.dispatch("UPTADE_ABOUT", [option]);
			},
			removeImage(index) {
				this.$store.dispatch("ABOUT_REMOVE_PICTURE", [index]);
			},
		},
		computed: {
			getSiteName() {
				return this.$store.state.wizard.dataSite.siteName;
			},
			aboutPictures() {
				return this.$store.state.wizard.dataSite.aboutSetup.images;
			},
			getSegment() {
				return this.$store.state.wizard.dataSite.segment;
			},
		}
	};
</script>

<style>
	.card--image img {
		height: 80px;
		object-fit: cover;
	}
	.media--manager {
		position: fixed;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		z-index: 3;
		background-color: #fff;
		overflow-y: auto;
	}
	.title--about {
		font-size: 1.5rem;
		margin: 0 0 10px 0;
		font-family: "Montserrat", sans-serif;
	}
	.card {
		cursor: pointer;
	}
	.card.active {
		border: 2px solid var(--main-color);
	}
	.span-close {
		position: absolute;
		right: 18px;
		top: 0px;
	}
	.tagai {
		background: var(--color__primary);
		color: #fff;
		border-radius: 20px;
		font-size: 12px;
		padding: 5px 10px;
		display: unset;
		margin-bottom: 10px;
		width: 215px;
		text-align: center;
	}
</style>


// WEBPACK FOOTER //
// src/components/organisms/StepWizardAbout.vue